import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';

export const AdminSuiteRoutes: RouteRecordRaw[] = [
    {
        path: '',
        redirect: '/admin/suite/locations'
    },
    {
        path: 'locations',
        component: wrapRuntimeImport(() => import('./screens/locations.vue')),
        meta: { admin: true }
    },
    {
        path: 'installs',
        component: wrapRuntimeImport(() => import('./screens/installs.vue')),
        meta: { admin: true }
    }
];
